import { shape, oneOf } from "prop-types";

const additionalValues = ["auto", "full", "screen", "px"];
const additionalMinValues = ["full", "screen"];
const additionalMaxValues = ["full", "screen"];

const values = [
	0,
	1,
	2,
	3,
	4,
	5,
	6,
	7,
	8,
	9,
	10,
	11,
	12,
	13,
	14,
	15,
	16,
	17,
	18,
	19,
	20,
	21,
	22,
	23,
	24,
	25,
	26,
	27,
	28,
	29,
	30,
	31,
	32,
	33,
	34,
	35,
	36,
	37,
	38,
	39,
	40,
	41,
	42,
	43,
	44,
	45,
	46,
	47,
	48,
	49,
	50,
	51,
	52,
	53,
	54,
	55,
	56,
	57,
	58,
	59,
	60,
	61,
	62,
	63,
	64,
	65,
	66,
	67,
	68,
	69,
	70,
	71,
	72,
	73,
	74,
	75,
	76,
	77,
	78,
	79,
	80,
	81,
	82,
	83,
	84,
	85,
	86,
	87,
	88,
	89,
	90,
	91,
	92,
	93,
	94,
	95,
	96,
	97,
	98,
	99,
	100,
	101,
	102,
	103,
	104,
	105,
	106,
	107,
	108,
	109,
	110,
	111,
	112,
	113,
	114,
	115,
	116,
	117,
	118,
	119,
	120,
	121,
	122,
	123,
	124,
	125,
	126,
	127,
	128,
	129,
	130,
	131,
	132,
	133,
	134,
	135,
	136,
	137,
	138,
	139,
	140,
	141,
	142,
	143,
	144,
	145,
	146,
	147,
	148,
	149,
	150,
	151,
	152,
	153,
	154,
	155,
	156,
	157,
	158,
	159,
	160,
	161,
	162,
	163,
	164,
	165,
	166,
	167,
	168,
	169,
	170,
	171,
	172,
	173,
	174,
	175,
	176,
	177,
	178,
	179,
	180,
	181,
	182,
	183,
	184,
	185,
	186,
	187,
	188,
	189,
	190,
	191,
	192,
	193,
	194,
	195,
	196,
	197,
	198,
	199,
	200,
];

const maskProps = {
	h: null,
	w: null,
	minH: null,
	minW: null,
	maxH: null,
	maxW: null,
};

const maskPropTypes = {
	h: oneOf([...additionalValues, ...values]),
	w: oneOf([...additionalValues, ...values]),
	minH: oneOf([...additionalMinValues, ...values]),
	minW: oneOf([...additionalMinValues, ...values]),
	maxH: oneOf([...additionalMaxValues, ...values]),
	maxW: oneOf([...additionalMaxValues, ...values]),
};

export const sizingProps = {
	...maskProps,
	sm: {
		...maskProps,
	},
	md: {
		...maskProps,
	},
	lg: {
		...maskProps,
	},
};

export const sizingPropTypes = shape({
	...maskPropTypes,
	sm: shape({
		...maskPropTypes,
	}),
	md: shape({
		...maskPropTypes,
	}),
	lg: shape({
		...maskPropTypes,
	}),
});

const checkValue = value => values.indexOf(value) !== -1;
const checkAdditionalValues = value => additionalValues.indexOf(value) !== -1;
const checkAdditionalMinValues = value => additionalMinValues.indexOf(value) !== -1;
const checkAdditionalMaxValues = value => additionalMaxValues.indexOf(value) !== -1;

const responsiveCheckValues = (h, w, minH, minW, maxH, maxW, media = null, mediaName = "") => {
	if (media) {
		return [
			(checkValue(media.h) || checkAdditionalValues(media.h)) && `h-${media.h}--${mediaName}`,
			(checkValue(media.w) || checkAdditionalValues(media.w)) && `w-${media.w}--${mediaName}`,
			media.minH &&
				(checkValue(media.minH) || checkAdditionalMinValues(media.minH)) &&
				`min-h-${media.minH}--${mediaName}`,
			media.minW &&
				(checkValue(media.minW) || checkAdditionalMinValues(media.minW)) &&
				`min-w-${media.minW}--${mediaName}`,
			media.maxH &&
				(checkValue(media.maxH) || checkAdditionalMaxValues(media.maxH)) &&
				`max-h-${media.maxH}--${mediaName}`,
			media.maxW &&
				(checkValue(media.maxW) || checkAdditionalMaxValues(media.maxW)) &&
				`max-w-${media.maxW}--${mediaName}`,
		];
	}
	return [
		(checkValue(w) || checkAdditionalValues(w)) && `w-${w}`,
		(checkValue(h) || checkAdditionalValues(h)) && `h-${h}`,
		(checkValue(minH) || checkAdditionalMinValues(minH)) && `min-h-${minH}`,
		(checkValue(minW) || checkAdditionalMinValues(minW)) && `min-w-${minW}`,
		(checkValue(maxH) || checkAdditionalMaxValues(maxH)) && `max-h-${maxH}`,
		(checkValue(maxW) || checkAdditionalMaxValues(maxW)) && `max-w-${maxW}`,
	];
};

// TODO: can be expanded if needed (min-w / max-w / min-h / max-w)
export const sizingClassName = ({ h, w, minH, minW, maxH, maxW, sm, md, lg }) => {
	const sizingClass = [
		...responsiveCheckValues(h, w, minH, minW, maxH, maxW),
		...responsiveCheckValues(h, w, minH, minW, maxH, maxW, sm, "sm"),
		...responsiveCheckValues(h, w, minH, minW, maxH, maxW, md, "md"),
		...responsiveCheckValues(h, w, minH, minW, maxH, maxW, lg, "lg"),
	];

	return sizingClass.filter(Boolean);
};
